import http from '@/requests/http'
import appConfig from '@/config/app'

class AgentOutboundDetailsReport {
  static findAll (params) {
    return http.post('agents/outbound-details/reports/index', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/agents/outbound-details/reports/export?${URLparams}`, '_blank')
  }
}

export default AgentOutboundDetailsReport
